
import React, {Component} from 'react'
import Main from './components/main/main'
import {BrowserRouter} from 'react-router-dom'
import Auth from './components/main/auth'
import {auth} from './components/main/firebase'
import {db } from './components/main/firebase'
import List from './components/main/list'
import Addpost from './components/main/addpost'


class App extends Component {
  state={
    
  }

  render(){
    return(
      <BrowserRouter>
          <Main />       
      </BrowserRouter>
    )
  }
}
export default App